export default "__VITE_ASSET__nsY3Y9gE__"